// this file added by Bearer Web Developer
import React from "react";
import styles from './send.module.scss';
import { Button } from "@mui/material";
import { useAppState } from "../../../../../../../states/app-state";
import { validateMobileCode } from "../../../validation";
import { useThemeMode } from "../../../../../../../states/contexts/theme";


interface Props {
    setLoading: React.Dispatch<React.SetStateAction<boolean>>
}
const Send: React.FC<Props> = ({ setLoading }) => {

    const appState = useAppState();
    const { accountVerification } = appState;
    const checkValidation = () => (!validateMobileCode(accountVerification.mobileCode))
    const handleClick = async () => {
        if (!checkValidation()) return;
        setLoading(true);
        const result = await accountVerification?.fetchRegisterBusinessCustomerConfirmSMSCode();
        if (result?.code === 200) accountVerification?.setMobileCodeSituation("Verified");
        setLoading(false);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.send_part} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <Button className={styles.send} disableRipple={true}
                onClick={handleClick} disabled={!checkValidation()} >Verify</Button>
        </div>
    )
}
export default Send;